(function () {
  const root = document.querySelector('[data-cookie-banner]');
  if (!root) return;

  const preferencesPanel = root.querySelector('[data-cookie-preferences]');
  const acceptButton = root.querySelector('[data-cookie-accept]');
  const declineButton = root.querySelector('[data-cookie-decline]');
  const customizeButton = root.querySelector('[data-cookie-customize]');
  const saveButton = root.querySelector('[data-cookie-save]');
  const showInDesignMode = root.dataset.showInDesignMode === 'true';

  function hideBanner() {
    root.hidden = true;
  }

  function showBanner() {
    root.hidden = false;
  }

  function getPreferenceValues() {
    return {
      analytics: Boolean(root.querySelector('[data-consent-key="analytics"]')?.checked),
      marketing: Boolean(root.querySelector('[data-consent-key="marketing"]')?.checked),
      preferences: Boolean(root.querySelector('[data-consent-key="preferences"]')?.checked),
    };
  }

  function setConsent(consent) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      hideBanner();
      return;
    }

    privacy.setTrackingConsent(consent, hideBanner);
  }

  function acceptAll() {
    setConsent({ analytics: true, marketing: true, preferences: true });
  }

  function declineAll() {
    setConsent({ analytics: false, marketing: false, preferences: false });
  }

  function savePreferences() {
    setConsent(getPreferenceValues());
  }

  function togglePreferences() {
    if (!preferencesPanel) return;
    preferencesPanel.hidden = !preferencesPanel.hidden;
  }

  function initBanner(error) {
    if (error) {
      console.warn('Cookie banner: Customer Privacy API failed to load', error);
      return;
    }

    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;

    const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (inDesignMode && showInDesignMode) {
      showBanner();
      return;
    }

    if (typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()) {
      showBanner();
    }
  }

  acceptButton?.addEventListener('click', acceptAll);
  declineButton?.addEventListener('click', declineAll);
  customizeButton?.addEventListener('click', togglePreferences);
  saveButton?.addEventListener('click', savePreferences);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    return;
  }

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    initBanner
  );
})();
